import script from "./ProductsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsContainer.vue?vue&type=style&index=0&id=66b8051f&lang=css"

const __exports__ = script;

export default __exports__